/** F8 - pt, en e es trocando ao vivo. Dicionario com chave por area. */
import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from 'react';
import { DICIONARIO_DOS_MODULOS } from '../modules/registro.ts';

export type Idioma = 'pt' | 'en' | 'es';
export const IDIOMAS: readonly Idioma[] = ['pt', 'en', 'es'];

const dicionario = {
  pt: {
    'app.nome': 'TME',
    'menu.inicio': 'Início',
    'menu.leads': 'Leads e reabordagem',
    'menu.comercial': 'Tarefas',
    'menu.turmas': 'Cursos e turmas',
    'menu.pessoas': 'Alunos e pessoas',
    'menu.contratos': 'Contratos',
    'menu.integracoes': 'Integrações',
    'menu.configuracoes': 'Configurações',
    'menu.admin': 'Admin',
    'app.subtitulo': 'Terapia Manual Evolutiva',
    'login.titulo': 'Entrar',
    'login.subtitulo': 'Acesse o painel da sua operação.',
    'login.email': 'E-mail',
    'login.senha': 'Senha',
    'login.entrar': 'Entrar',
    'login.entrando': 'Entrando',
    'login.esqueci': 'Esqueci minha senha',
    'login.marca.frase': 'Um sistema, todos os módulos que a sua operação usa.',
    'senha.esqueci.titulo': 'Esqueci minha senha',
    'senha.esqueci.texto': 'Informe o e-mail de acesso. Se ele estiver cadastrado, você recebe um link para criar uma senha nova.',
    'senha.esqueci.enviar': 'Enviar link',
    'senha.esqueci.enviado': 'Se existir uma conta com este e-mail, o link foi enviado. Ele vale por 30 minutos.',
    'senha.voltar': 'Voltar ao login',
    'senha.convite.titulo': 'Crie a sua senha',
    'senha.convite.texto': 'Você recebeu um convite. Escolha a senha que vai usar para entrar.',
    'senha.nova.titulo': 'Defina uma senha nova',
    'senha.nova.texto': 'Escolha a senha nova. As sessões abertas com a senha antiga são encerradas.',
    'senha.campo': 'Senha nova',
    'senha.confirmar': 'Repita a senha nova',
    'senha.regra': 'Ao menos 12 caracteres.',
    'senha.salvar': 'Salvar senha',
    'senha.pronto': 'Senha salva. Já pode entrar com ela.',
    'senha.entrar': 'Ir para o login',
    'senha.erro.diferentes': 'As duas senhas não são iguais.',
    'senha.erro.curta': 'A senha precisa de ao menos 12 caracteres.',
    'senha.erro.link': 'Este link não vale mais. Peça um novo.',
    'senha.erro.generico': 'Não foi possível salvar. Tente de novo.',
    'conta.titulo': 'Minha conta',
    'conta.trocar': 'Trocar senha',
    'conta.atual': 'Senha atual',
    'conta.ok': 'Senha trocada. As outras sessões abertas foram encerradas.',
    'conta.erro.atual': 'A senha atual não confere.',
    'conta.erro.igual': 'A senha nova precisa ser diferente da atual.',
    'conta.erro.muitas': 'Muitas tentativas. Espere alguns minutos.',
    'shell.conta': 'Minha conta',
    'erro.credenciais': 'E-mail ou senha incorretos.',
    'erro.muitas': 'Muitas tentativas. Aguarde e tente de novo.',
    'erro.rede': 'Não foi possível falar com o servidor.',
    'shell.sair': 'Sair',
    'shell.recolher': 'Recolher menu',
    'shell.expandir': 'Expandir menu',
    'shell.tema': 'Tema',
    'shell.idioma': 'Idioma',
    'shell.workspace': 'Workspace',
    'estado.vazio.titulo': 'Nada aqui ainda',
    'estado.vazio.texto': 'Os registros aparecem nesta tela conforme forem criados.',
    'estado.carregando': 'Carregando',
    'estado.erro.titulo': 'Algo falhou',
    'inicio.kicker': 'Hoje na TME',
    'inicio.titulo': 'Início',
    'inicio.texto': 'As reabordagens, fichas a conferir e tarefas do dia aparecem aqui.',
  },
  en: {
    'app.nome': 'TME',
    'menu.inicio': 'Home',
    'menu.leads': 'Leads',
    'menu.comercial': 'Tasks',
    'menu.turmas': 'Courses and classes',
    'menu.pessoas': 'Students and people',
    'menu.contratos': 'Contracts',
    'menu.integracoes': 'Integrations',
    'menu.configuracoes': 'Settings',
    'menu.admin': 'Admin',
    'app.subtitulo': 'Terapia Manual Evolutiva',
    'login.titulo': 'Sign in',
    'login.subtitulo': 'Access your operations panel.',
    'login.email': 'Email',
    'login.senha': 'Password',
    'login.entrar': 'Sign in',
    'login.entrando': 'Signing in',
    'login.esqueci': 'Forgot my password',
    'login.marca.frase': 'One system, every module your operation uses.',
    'senha.esqueci.titulo': 'Forgot my password',
    'senha.esqueci.texto': 'Enter your sign-in email. If it is registered, you get a link to create a new password.',
    'senha.esqueci.enviar': 'Send link',
    'senha.esqueci.enviado': 'If there is an account with this email, the link was sent. It is valid for 30 minutes.',
    'senha.voltar': 'Back to sign in',
    'senha.convite.titulo': 'Create your password',
    'senha.convite.texto': 'You received an invitation. Choose the password you will use to sign in.',
    'senha.nova.titulo': 'Set a new password',
    'senha.nova.texto': 'Choose the new password. Sessions open with the old one are ended.',
    'senha.campo': 'New password',
    'senha.confirmar': 'Repeat the new password',
    'senha.regra': 'At least 12 characters.',
    'senha.salvar': 'Save password',
    'senha.pronto': 'Password saved. You can sign in with it now.',
    'senha.entrar': 'Go to sign in',
    'senha.erro.diferentes': 'The two passwords do not match.',
    'senha.erro.curta': 'The password needs at least 12 characters.',
    'senha.erro.link': 'This link is no longer valid. Ask for a new one.',
    'senha.erro.generico': 'Could not save. Try again.',
    'conta.titulo': 'My account',
    'conta.trocar': 'Change password',
    'conta.atual': 'Current password',
    'conta.ok': 'Password changed. Other open sessions were ended.',
    'conta.erro.atual': 'The current password does not match.',
    'conta.erro.igual': 'The new password must be different from the current one.',
    'conta.erro.muitas': 'Too many attempts. Wait a few minutes.',
    'shell.conta': 'My account',
    'erro.credenciais': 'Incorrect email or password.',
    'erro.muitas': 'Too many attempts. Wait and try again.',
    'erro.rede': 'Could not reach the server.',
    'shell.sair': 'Sign out',
    'shell.recolher': 'Collapse menu',
    'shell.expandir': 'Expand menu',
    'shell.tema': 'Theme',
    'shell.idioma': 'Language',
    'shell.workspace': 'Workspace',
    'estado.vazio.titulo': 'Nothing here yet',
    'estado.vazio.texto': 'Records show up on this screen as they are created.',
    'estado.carregando': 'Loading',
    'estado.erro.titulo': 'Something failed',
    'inicio.kicker': 'Dashboard',
    'inicio.titulo': 'Home',
    'inicio.texto': 'Indicators from installed modules show up here.',
  },
  es: {
    'app.nome': 'TME',
    'menu.inicio': 'Inicio',
    'menu.leads': 'Leads',
    'menu.comercial': 'Tareas',
    'menu.turmas': 'Cursos y grupos',
    'menu.pessoas': 'Alumnos y personas',
    'menu.contratos': 'Contratos',
    'menu.integracoes': 'Integraciones',
    'menu.configuracoes': 'Configuración',
    'menu.admin': 'Admin',
    'app.subtitulo': 'Terapia Manual Evolutiva',
    'login.titulo': 'Entrar',
    'login.subtitulo': 'Accede al panel de tu operación.',
    'login.email': 'Correo',
    'login.senha': 'Contraseña',
    'login.entrar': 'Entrar',
    'login.entrando': 'Entrando',
    'login.esqueci': 'Olvidé mi contraseña',
    'login.marca.frase': 'Un sistema, todos los módulos que usa tu operación.',
    'senha.esqueci.titulo': 'Olvidé mi contraseña',
    'senha.esqueci.texto': 'Indique el correo de acceso. Si está registrado, recibirá un enlace para crear una contraseña nueva.',
    'senha.esqueci.enviar': 'Enviar enlace',
    'senha.esqueci.enviado': 'Si existe una cuenta con este correo, el enlace fue enviado. Vale 30 minutos.',
    'senha.voltar': 'Volver al inicio de sesión',
    'senha.convite.titulo': 'Cree su contraseña',
    'senha.convite.texto': 'Recibió una invitación. Elija la contraseña que usará para entrar.',
    'senha.nova.titulo': 'Defina una contraseña nueva',
    'senha.nova.texto': 'Elija la contraseña nueva. Las sesiones abiertas con la anterior se cierran.',
    'senha.campo': 'Contraseña nueva',
    'senha.confirmar': 'Repita la contraseña nueva',
    'senha.regra': 'Al menos 12 caracteres.',
    'senha.salvar': 'Guardar contraseña',
    'senha.pronto': 'Contraseña guardada. Ya puede entrar con ella.',
    'senha.entrar': 'Ir al inicio de sesión',
    'senha.erro.diferentes': 'Las dos contraseñas no coinciden.',
    'senha.erro.curta': 'La contraseña necesita al menos 12 caracteres.',
    'senha.erro.link': 'Este enlace ya no vale. Pida uno nuevo.',
    'senha.erro.generico': 'No se pudo guardar. Intente de nuevo.',
    'conta.titulo': 'Mi cuenta',
    'conta.trocar': 'Cambiar contraseña',
    'conta.atual': 'Contraseña actual',
    'conta.ok': 'Contraseña cambiada. Las otras sesiones abiertas se cerraron.',
    'conta.erro.atual': 'La contraseña actual no coincide.',
    'conta.erro.igual': 'La contraseña nueva debe ser distinta de la actual.',
    'conta.erro.muitas': 'Demasiados intentos. Espere unos minutos.',
    'shell.conta': 'Mi cuenta',
    'erro.credenciais': 'Correo o contraseña incorrectos.',
    'erro.muitas': 'Demasiados intentos. Espera e intenta de nuevo.',
    'erro.rede': 'No se pudo contactar el servidor.',
    'shell.sair': 'Salir',
    'shell.recolher': 'Contraer menú',
    'shell.expandir': 'Expandir menú',
    'shell.tema': 'Tema',
    'shell.idioma': 'Idioma',
    'shell.workspace': 'Workspace',
    'estado.vazio.titulo': 'Aún no hay nada',
    'estado.vazio.texto': 'Los registros aparecerán en esta pantalla al crearse.',
    'estado.carregando': 'Cargando',
    'estado.erro.titulo': 'Algo fallo',
    'inicio.kicker': 'Panel',
    'inicio.titulo': 'Inicio',
    'inicio.texto': 'Los indicadores de los módulos instalados aparecerán aquí.',
  },
} as const;

export type Chave = keyof typeof dicionario.pt;

type Ctx = { idioma: Idioma; t: (c: Chave) => string; trocar: (i: Idioma) => void };
const contexto = createContext<Ctx | null>(null);

const inicial = (): Idioma => {
  try {
    const g = localStorage.getItem('erp_idioma');
    if (g === 'pt' || g === 'en' || g === 'es') return g;
  } catch { /* storage bloqueado */ }
  return 'pt';
};

export function ProvedorIdioma({ children }: { children: ReactNode }) {
  const [idioma, setIdioma] = useState<Idioma>(inicial);

  const trocar = useCallback((i: Idioma) => {
    setIdioma(i);
    document.documentElement.lang = i;
    try { localStorage.setItem('erp_idioma', i); } catch { /* ignora */ }
  }, []);

  // O nucleo primeiro, depois os modulos, e por fim a propria chave. Assim um
  // modulo nunca sobrescreve texto do nucleo, e chave sem traducao aparece
  // como ela mesma em vez de sumir.
  const t = useCallback(
    (c: Chave): string =>
      dicionario[idioma][c]
      ?? DICIONARIO_DOS_MODULOS[idioma][c]
      ?? dicionario.pt[c]
      ?? DICIONARIO_DOS_MODULOS.pt[c]
      ?? c,
    [idioma],
  );

  const valor = useMemo(() => ({ idioma, t, trocar }), [idioma, t, trocar]);
  return <contexto.Provider value={valor}>{children}</contexto.Provider>;
}

export function useIdioma(): Ctx {
  const c = useContext(contexto);
  if (c === null) throw new Error('useIdioma precisa estar dentro de ProvedorIdioma');
  return c;
}
